import { useInfiniteQuery } from "react-query";
import { api } from "utils/api";
import { collectiveKeys } from "./queryKeys";
import type {
  CollectivesSearchRequest,
  CollectivesSearchResponse,
} from "../types";

const getCollectives = (params: CollectivesSearchRequest) =>
  api.post<CollectivesSearchResponse>("/collective/search", {
    body: JSON.stringify(params),
  });

const useCollectives = (params: CollectivesSearchRequest = {}) =>
  useInfiniteQuery(
    collectiveKeys.list(params),
    ({ pageParam }) => getCollectives({ ...params, searchAfter: pageParam }),
    {
      getNextPageParam: (lastPage) => lastPage.searchAfter,
    }
  );

export { useCollectives };
